import React, { useRef, useEffect } from 'react';

/**
 * 마우스 움직임에 따라 배경의 여러 원형 도형(orb)이 서로 다른 속도로 움직이는
 * 패럴럭스 배경. 각 orb 의 이동 배율은 styles/components/parallax.css 에서
 * 정의한다 (여기서는 --parallax-x/--parallax-y 값만 갱신한다).
 *
 * 부모 요소는 반드시 position: relative (또는 fixed/absolute) 여야 하고,
 * overflow: hidden 을 주는 것을 권장한다 (로그인 화면의 .login-screen 참고).
 */
export default function ParallaxBackground() {
  const ref = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      // 화면 중앙 기준 -1 ~ 1 범위로 정규화
      const x = (e.clientX / innerWidth - 0.5) * 2;
      const y = (e.clientY / innerHeight - 0.5) * 2;
      if (ref.current) {
        ref.current.style.setProperty('--parallax-x', x.toFixed(3));
        ref.current.style.setProperty('--parallax-y', y.toFixed(3));
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="parallax-bg" ref={ref} aria-hidden="true">
      <div className="parallax-orb parallax-orb-1" />
      <div className="parallax-orb parallax-orb-2" />
      <div className="parallax-orb parallax-orb-3" />
    </div>
  );
}
